export default __webpack_public_path__ + "static/codeleap_logo_black-89bd4333a16026234d0ba5a59a8a11d2.webp";